module.exports = __webpack_public_path__ + "static/media/trust_ff1_stacked.f5816bd1.svg";